import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {ServiceFunctionRealtimeChange} from "@project/sdk/realtime";

import {serviceFunctionKeys} from "../serviceFunction-keys";

type ServiceFunctionRealtimeChangeEvent = output<typeof ServiceFunctionRealtimeChange>;

export const serviceFunctionsRealtimeHandler: ResourceChangeRealtimeHandler<ServiceFunctionRealtimeChangeEvent> =
  {
    resource: "engineering.service-functions",
    queryKey: serviceFunctionKeys.all,
    eventSchema: ServiceFunctionRealtimeChange,
    async handleEvent(event, queryClient) {
      if (event.change === "CREATED") {
        await queryClient.invalidateQueries({queryKey: serviceFunctionKeys.lists()});
        return;
      }
      await queryClient.invalidateQueries({queryKey: serviceFunctionKeys.all});
    },
  };
